export const configuration = {
  header: {
    heading: 'The Photographer',
    headingtext:
      'Bijay Chapagain',
    buttontext: 'do some action',
    buttonlink: '\home'
  }
};
